import type { TextFieldProps } from '@mui/material';

import { MenuItem, TextField } from '@mui/material';

type Priority = 'all' | 'required' | 'optional';

interface FormPrioritySelectProps
  extends Omit<TextFieldProps, 'value' | 'onChange' | 'children'> {
  value?: Priority;
  onChange?: (value: Priority) => void;
}

export function FormPrioritySelect(props: FormPrioritySelectProps) {
  return (
    <TextField
      select
      size="small"
      color="primary"
      label="Form Priority"
      {...props}
      onChange={(event) => props.onChange?.(event.target.value as Priority)}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="required">Required</MenuItem>
      <MenuItem value="optional">Optional</MenuItem>
    </TextField>
  );
}
